import { RewistaTobaccoService } from './rewistaTobaccoService';
import { AxiosResponse } from 'axios';
import { DeliveryNote } from '@/customTypes';

export default class DeliveryNoteService extends RewistaTobaccoService {
    public async getLastDeliveryNotes(): Promise<DeliveryNote[]> {
        const response = await this.axiosDeliveryNoteRequest();
        if (response.status !== 200) {
            return new Array<DeliveryNote>();
        }
        return response.data;
    }
    private async axiosDeliveryNoteRequest(): Promise<AxiosResponse<DeliveryNote[]>> {
        return await this.axios.get<DeliveryNote[]>('TransactionalDocument/GetLastDeliveryNotes');
    }
}
